import { Component, Inject, Input, OnChanges, SimpleChanges } from '@angular/core';

import { WINDOW } from '@shared/services/window.service';

// Icons
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'cwk-error-alert',
  templateUrl: './error-alert.component.html',
  styleUrls: ['./error-alert.component.scss'],
  standalone: false
})
export class ErrorAlertComponent implements OnChanges {

  @Input() error: any;
  @Input() isHomeApp = true;

  // Icons
  faExclamationTriangle = faExclamationTriangle;

  // Model
  displayError: any;
  isHtml = false;
  isText = false;

  constructor(
    @Inject(WINDOW) private window: Window | null
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes['error']) {
      return;
    }
    this.displayError = this.error?.FriendlyMessage || this.error;
    this.isText = typeof this.displayError === 'string';
    this.isHtml = this.isText && this.isHtmlString(this.displayError);
  }

  refresh() {
    if (this.window) {
      this.window.location.reload();
    }
  }

  private isHtmlString(value: string): boolean {
    return /^(<!doctype html|<html|<body)\b/i.test(value.trim());
  }
}
